interface MetricSelectionAction {
  metricName: string
  isSelected: boolean
}

export function hasReachedMetricSelectionLimit(
  selectionCount: number,
  maxSelections?: number,
): boolean {
  return maxSelections !== undefined && selectionCount >= maxSelections
}

export function buildSelectAllMetricActions(
  metricNames: string[],
  selectedMetrics: string[],
  maxSelections?: number,
  selectionCount = selectedMetrics.length,
): MetricSelectionAction[] {
  const selectedMetricNames = new Set(selectedMetrics)
  if (metricNames.every((metricName) => selectedMetricNames.has(metricName))) {
    return metricNames.map((metricName) => ({
      metricName,
      isSelected: false,
    }))
  }

  const remainingSelections =
    maxSelections === undefined
      ? metricNames.length
      : Math.max(maxSelections - selectionCount, 0)
  return metricNames
    .filter((metricName) => !selectedMetricNames.has(metricName))
    .slice(0, remainingSelections)
    .map((metricName) => ({ metricName, isSelected: true }))
}

export function buildMetricToggleActions(
  metricName: string,
  isSelected: boolean,
  selectedMetrics: string[],
  allowMultipleSelection: boolean,
  maxSelections?: number,
  selectionCount = selectedMetrics.length,
): MetricSelectionAction[] {
  if (
    allowMultipleSelection &&
    isSelected &&
    hasReachedMetricSelectionLimit(selectionCount, maxSelections)
  ) {
    return []
  }
  const deselections =
    !allowMultipleSelection && isSelected
      ? selectedMetrics
          .filter((selectedMetric) => selectedMetric !== metricName)
          .map((selectedMetric) => ({
            metricName: selectedMetric,
            isSelected: false,
          }))
      : []
  return [...deselections, { metricName, isSelected }]
}
